import sizeOfViabillLogo from "size.js!=!odendo-image-size-loader?module!../../shop-checkout/payment-methods/viabill.png?width=76";
import viabillLogo76 from "odendo-image-resizer?module!../../shop-checkout/payment-methods/viabill.png?width=76";
import viabillLogo152 from "odendo-image-resizer?module!../../shop-checkout/payment-methods/viabill.png?width=152";
import viabillLogo228 from "odendo-image-resizer?module!../../shop-checkout/payment-methods/viabill.png?width=228";
import { createPaymentImageData } from "./base";

export const imageData = createPaymentImageData(
    sizeOfViabillLogo,
    {
        url: viabillLogo76,
        width: 76,
    },
    {
        url: viabillLogo152,
        width: 152,
    },
    {
        url: viabillLogo228,
        width: 228,
    }
);
